(function () {
  function setup() {
    if ($("body.pages.home").length == 0) return; //make it page specific

    // HOME MAP HOVER HANDLING
    // -----------------
    let previouslyHoveredRegion = null;
    $(".home-map a").on("mouseenter", (e) => {
      if (e.currentTarget === previouslyHoveredRegion) return; // do nothing if we are hovering the same region as before
      previouslyHoveredRegion = e.currentTarget;

      console.log("mouseenter", e.currentTarget);
      $(".home-map a polygon.hovered").removeClass("hovered");

      e.currentTarget.parentNode.appendChild(e.currentTarget); // brings SVG polygon to front (Z-index-wise) when mouseover so effects are properly rendered
      e.currentTarget.firstElementChild.setAttribute("class", "hovered");
      const label = $(e.currentTarget.parentNode.parentNode.parentNode).find(
        ".home-map-label",
      );
      label
        .find("span")
        .text(
          $(e.currentTarget).attr("data-title") +
            ($(e.currentTarget).attr("data-count")
              ? " [" + $(e.currentTarget).attr("data-count") + "]"
              : ""),
        );
      //we center the label above the region..
      const labelWidth = label.outerWidth();
      const polyBBox =
        e.currentTarget.firstElementChild.getBoundingClientRect();
      const svgBBox =
        e.currentTarget.parentNode.parentNode.getBoundingClientRect();
      const relativeTop = polyBBox.top - svgBBox.top;
      const relativeLeft = polyBBox.left - svgBBox.left;
      label.css("top", relativeTop - 50 + "px");
      label.css(
        "left",
        relativeLeft + polyBBox.width / 2 - labelWidth / 2 + "px",
      );
      label.show();
    });

    $(".home-map a").on("mouseleave", (e) => {
      console.log("mouseleave", e.currentTarget);
      e.currentTarget.firstElementChild.setAttribute("class", "");
      const label = $(e.currentTarget.parentNode.parentNode.parentNode).find(
        ".home-map-label",
      );
      label.hide();
    });

    // NAVBAR BUTOTNS AND MENUS HANDLING
    //

    //Toto je kvoli funkcionalite navbar more categories a language na mobiloch spravit to mozno(cele) aby sa loadoval iba na home stranke
    $("#more-categories-link .nav-link").on("click", (e) => {
      $("#more-categories-bubble-wrapper").toggle();
      $("#languages-bubble-wrapper").hide();
      return false; //prevent propagation or otherwise it other events would also close the bubble immediately
    });
    $("#more-categories-bubble").on("click", (e) => {
      //stop event if we click inside bubble.. other wise next callbacks would close it
      if (e.target.nodeName !== "A") return false;
    });
    $("#select-language-link .nav-link").on("click", (e) => {
      $("#more-categories-bubble-wrapper").hide();
      return false; //prevent propagation or otherwise it other events would also close the bubble immediately
    });
    $(window).on("scroll", (e) => {
      $("#more-categories-bubble-wrapper").hide();
    });

    $("#home-header").on("click", (e) => {
      $("#more-categories-bubble-wrapper").hide();
      //return false;
    });

    //districts list toggling
    $("#regions-section .districts-list .toggler").on("click", (e) => {
      $(e.currentTarget).toggleClass("collapsed");
      $("#" + $(e.currentTarget).attr("data-toggle")).toggle();
      return false;
    });

    //map tab toggle
    $("#home-map-container .map-switcher a.btn").on("click", (e) => {
      const tabContent = $($(e.currentTarget).attr("data-target"));
      tabContent.addClass("active show");
      tabContent.siblings().removeClass("active show");
      $(e.currentTarget).addClass("active");
      $(e.currentTarget).siblings().removeClass("active");
    });

    FAVOURITES.markAllFavourited();
  }

  function teardown() {
    if ($("body.pages.home").length == 0) return; //make it page specific
  }

  $(document).on("DOMContentLoaded", setup); //turbolinks:load
  //$(document).on("turbolinks:before-cache", teardown);
})();
